/*
 *  jQuery StarRatingSvg v1.0.1
 *
 *  http://github.com/nashio/star-rating-svg
 *  Author: Ignacio Chavez
 *  Licensed under MIT
 *
 *  !!! EDITED STARS !!!
 */

; (function ($, window, document, undefined) {

    'use strict';

    // Create the defaults once
    var pluginName = 'starRating';
    var noop = function () { };
    var defaults = {
        totalStars: 5,
        useFullStars: false,
        emptyColor: 'lightgray',
        hoverColor: 'orange',
        activeColor: 'gold',
        useGradient: true,
        readOnly: false,
        disableAfterRate: true,
        starGradient: {
            start: '#FEF7CD',
            end: '#FF9511'
        },
        strokeWidth: 0,
        strokeColor: 'black',
        initialRating: 0,
        starSize: 40,
        callback: noop,
        onHover: noop,
        onLeave: noop
    };

    // The actual plugin constructor
    var Plugin = function (element, options) {
        var _rating;
        this.element = element;
        this.$el = $(element);
        this.settings = $.extend({}, defaults, options);

        // grab rating if defined on the element
        _rating = this.$el.data('rating') || this.settings.initialRating;
        this._state = {
            // round to the nearest half
            rating: (Math.round(_rating * 2) / 2).toFixed(1)
        };

        // create unique id for stars
        this._uid = Math.floor(Math.random() * 999);

        // override gradient if not used
        if (!options.starGradient && !this.settings.useGradient) {
            this.settings.starGradient.start = this.settings.starGradient.end = this.settings.activeColor;
        }

        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    };

    var methods = {
        init: function () {
            this.renderMarkup();
            this.addListeners();
            this.initRating();
        },

        addListeners: function () {
            if (this.settings.readOnly) { return; }
            this.$stars.on('mouseover', this.hoverRating.bind(this));
            this.$stars.on('mouseout', this.restoreState.bind(this));
            this.$stars.on('click', this.handleRating.bind(this));
        },

        // apply styles to hovered stars
        hoverRating: function (e) {
            var index = this.getIndex(e);
            this.paintStars(index, 'hovered');
            this.settings.onHover(index + 1, this._state.rating, this.$el);
        },

        // clicked on a rate, apply style and state
        handleRating: function (e) {
            var index = this.getIndex(e);
            var rating = index + 1;

            this.applyRating(rating, this.$el);
            this.executeCallback(rating, this.$el);

            if (this.settings.disableAfterRate) {
                this.$stars.off();
            }
        },

        applyRating: function (rating) {
            var index = rating - 1;
            // paint selected and remove hovered color
            this.paintStars(index, 'active');
            this._state.rating = index + 1;
        },

        restoreState: function (e) {
            var index = this.getIndex(e);
            var rating = this._state.rating || -1;
            this.paintStars(rating - 1, 'active');
            this.settings.onLeave(index + 1, this._state.rating, this.$el);
        },

        getIndex: function (e) {
            var $target = $(e.currentTarget);
            var width = $target.width();
            var side = $(e.target).attr('data-side');

            // hovered outside the star, calculate by pixel instead
            side = (!side) ? this.getOffsetByPixel(e, $target, width) : side;
            side = (this.settings.useFullStars) ? 'right' : side;

            // get index for half or whole star
            var index = $target.index() - ((side === 'left') ? 0.5 : 0);

            // pointer is way to the left, rating should be none
            index = (index < 0.5 && (e.offsetX < width / 4)) ? -1 : index;
            return index;
        },

        getOffsetByPixel: function (e, $target, width) {
            var leftX = e.pageX - $target.offset().left;
            return (leftX <= (width / 2) && !this.settings.useFullStars) ? 'left' : 'right';
        },

        initRating: function () {
            this.paintStars(this._state.rating - 1, 'active');
        },

        paintStars: function (endIndex, stateClass) {
            var $pathLeft;
            var $pathRight;
            var leftClass;
            var rightClass;

            $.each(this.$stars, function (index, star) {
                $pathLeft = $(star).find('path[data-side="left"]');
                $pathRight = $(star).find('path[data-side="right"]');
                leftClass = rightClass = (index <= endIndex) ? stateClass : 'empty';

                // has another half rating, add half star
                leftClass = (index - endIndex === 0.5) ? stateClass : leftClass;

                $pathLeft.attr('class', 'svg-' + leftClass + '-' + this._uid);
                $pathRight.attr('class', 'svg-' + rightClass + '-' + this._uid);

            }.bind(this));
        },

        renderMarkup: function () {
            // inject an svg manually to have control over attributes
            var star = `<div class="jq-star" style="width:${this.settings.starSize}px; height:${this.settings.starSize}px;"><svg version="1.0" class="jq-star-svg" shape-rendering="geometricPrecision" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                width="297px" height="297px" viewBox="0 0 297 297"
            xml:space="preserve">
                <style type="text/css">
                    .svg-empty-${this._uid} {fill: ${this.settings.emptyColor}}
                    .svg-hovered-${this._uid} {fill: ${this.settings.hoverColor}}
                    .svg-active-${this._uid} {fill: ${this.settings.activeColor}}
                </style>

                <path data-side="left" class="svg-empty-${this._uid}"
                    d="M148.499999,0 C148.667567,0 148.834204,0.00561235028 148.999719,0.0166937919 L148.999,2.518 L149.290258,2.54492365 C152.067542,2.86205336 152.462069,3.83330407 153.397617,6.66427599 C157.055898,18.9006627 159.923359,27.9424677 161.999999,33.7896909 C162.000364,33.7880238 162.000729,33.7863567 162.001094,33.7846895 L162,218.03125 L148.999,225.088 L148.998999,235.706 L148.499999,235.3428 L66.00132,295.5348 C63.27189,297.528 59.650635,297.48345 56.95173,295.42755 C54.3446829,293.425581 53.1838342,289.953747 54.0002486,286.692516 L54.07743,286.40535 L83.177985,185.5755 L3.103782,121.932195 C0.45064635,119.823825 -0.64720095,116.176335 0.3820311,112.84944 C1.37602909,109.616475 4.16716094,107.369922 7.37904917,107.184433 L7.647651,107.17377 L108.131265,105.025305 L141.127635,5.5073865 C142.21779,2.2085745 145.17591,0 148.499999,0 Z"
                ></path>

                <path data-side="right" class="svg-empty-${this._uid}"
                    d="M296.6172,112.84944 C295.59585,109.52667 292.677,107.245875 289.35225,107.17377 L188.8689,105.025305 L155.872365,5.5073865 C154.78221,2.2085745 151.82409,0 148.499884,0 C148.499884,0 148.499884,78.4476 148.499884,235.3428 L230.99835,295.5348 C232.3398,296.50995 233.89575,297.000121 235.4517,297.000121 C237.06705,297.000121 238.6758,296.47365 240.0486,295.42755 C242.7315,293.3667 243.8832,289.74825 242.9229,286.40535 L213.82185,185.5755 L293.89635,121.932195"
                ></path>
            </svg></div>`;

            // inject svg markup
            var starsMarkup = '';
            for (var i = 0; i < this.settings.totalStars; i++) {
                starsMarkup += star;
            }
            this.$el.append(starsMarkup);
            this.$stars = this.$el.find('.jq-star');
        },

        executeCallback: function (rating, $el) {
            var callback = this.settings.callback;
            callback(rating, $el);
        }

    };

    var publicMethods = {

        unload: function () {
            var _name = 'plugin_' + pluginName;
            var $el = $(this);
            var $starSet = $el.data(_name).$stars;
            $starSet.off();
            $el.removeData(_name).remove();
        },

        setRating: function (rating, round) {
            var _name = 'plugin_' + pluginName;
            var $el = $(this);
            var $plugin = $el.data(_name);
            if (rating > $plugin.settings.totalStars || rating < 0) { return; }
            if (round) {
                rating = Math.round(rating);
            }
            $plugin.applyRating(rating);
        },

        getRating: function () {
            var _name = 'plugin_' + pluginName;
            var $el = $(this);
            var $starSet = $el.data(_name);
            return $starSet._state.rating;
        }
    };


    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, methods);

    $.fn[pluginName] = function (options) {

        // if options is a public method
        if (!$.isPlainObject(options)) {
            if (publicMethods.hasOwnProperty(options)) {
                return publicMethods[options].apply(this, Array.prototype.slice.call(arguments, 1));
            } else {
                $.error('Method ' + options + ' does not exist on ' + pluginName + '.js');
            }
        }

        return this.each(function () {
            // preventing against multiple instantiations
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
            }
        });
    };

})(jQuery, window, document);


